const initialState = {
  newCommentsForm: false,
  comment: null,
};
export default initialState;
